import { queryOptions } from "@tanstack/react-query";
import { backendService } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const queryOptions_coreValuesAnalysis = (
	query: Parameters<
		typeof backendService.corevalues.coreValuesControllerGetFriendCheckCoreValueAnalysis
	>[0],
) =>
	queryOptions({
		queryKey: ["core-values", "analysis", query] as const,
		queryFn: (context) =>
			extractionWrapper(
				backendService.corevalues.coreValuesControllerGetFriendCheckCoreValueAnalysis(
					context.queryKey[2],
					{ signal: context.signal },
				),
			),
	});
